import { judeEnv } from "@/utils/util";
import { set } from "core-js/core/dict";
import Vue from "vue";
async function goMessage(mpImId, id) {
  console.log(11111);
  const environment = await judeEnv();
  if (environment.isFengChao) {
    if (Vue.prototype.isApiAppOpenService) {
      Vue.prototype.isApiAppOpenService = false;
      Vue.prototype.$cjc.apiAppOpenService({
        openType: 3,
        extinfo: {
          mpId: mpImId,
          mpMsgId: id
        }
      });
      setTimeout(() => {
        Vue.prototype.isApiAppOpenService = true;
      }, 1000);
    }
  } else {
    console.log(environment.isFengChao);
    Vue.prototype.$Message.error(`请在${Vue.prototype.APPName}上打开`);
  }
}
async function goServe(url, id, name, accessWay) {
  console.log(url, id, name, accessWay);
  const environment = await judeEnv();

  if (environment.isFengChao) {
    if (Vue.prototype.isApiAppOpenService) {
      Vue.prototype.isApiAppOpenService = false;
      console.log(Vue.prototype.isApiAppOpenService);
      Vue.prototype.$cjc.apiAppOpenService({
        openType: 1,
        extinfo: {
          id: id,
          serviceName: name,
          serviceUrl: url,
          accessWay: accessWay
        }
      });
      setTimeout(() => {
        Vue.prototype.isApiAppOpenService = true;
      }, 1000);
    }
  } else {
    console.log(environment.isFengChao);
    Vue.prototype.$Message.error(`请在${Vue.prototype.APPName}上打开`);
  }
}
async function goOfficialAccounts(id, name) {
  console.log(id, name);
  const environment = await judeEnv();
  if (environment.isFengChao) {
    if (Vue.prototype.isApiAppOpenService) {
      Vue.prototype.isApiAppOpenService = false;
      Vue.prototype.$cjc.apiAppOpenService({
        openType: 2,
        extinfo: {
          mpId: id,
          mpName: name
        }
      });
      setTimeout(() => {
        Vue.prototype.isApiAppOpenService = true;
      }, 1000);
    }
  } else {
    console.log(environment.isFengChao);
    Vue.prototype.$Message.error(`请在${Vue.prototype.APPName}上打开`);
  }
}
function messageImg(id) {
  console.log(1);
  let arr = document.getElementById(id);
  console.log(arr);
  arr.setAttribute("src", require("@/assets/zwx.png"));
  // arr.attr("src","/src/assets/zwx.png")
  console.log(arr, 11111);
}

export default {
  goMessage,
  goServe,
  goOfficialAccounts,
  messageImg
};
